export default __webpack_public_path__ + "static/media/icon-ai-green.ef78bc50.svg";